$(document).ready(function () {
  const target = document.getElementById("circular-ingredients");
  if (target) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          target.classList.add("active");
        } else {
          target.classList.remove("active");
        }
      },
      {
        threshold: Array.from({ length: 101 }, (_, i) => i / 100), // check every % of visibility
      }
    );
    observer.observe(target);
  }
});

// Restart animation at the base of animationend event (event only fires once the animation has fully completed)
const media = document.querySelector('#circular-ingredients .circular-pack-media');
if (media) {
  media.addEventListener("animationend", function () {
    // remove .active when animation reaches 100%
    const parent = document.getElementById("circular-ingredients");
    parent.classList.remove("active");
    // re-add after 2s
    setTimeout(() => {
      parent.classList.add("active");
    }, 1000);
  });
}

if($('#puff-cuttings').length > 0){
  // const puff_cuttings = document.getElementById("puff-cuttings");
  // const puff_cuttings_observer = new IntersectionObserver(
  //   ([entry]) => {
  //     if (entry.intersectionRatio >= 0.5) {
  //       puff_cuttings.classList.add("active");
  //     } else {
  //       puff_cuttings.classList.remove("active");
  //     }
  //   },
  //   {
  //     threshold: 0.5, // 50% of the section must be visible
  //   }
  // );
  // puff_cuttings_observer.observe(puff_cuttings);

  const $puff_cuttings_slides = $('.puff-cuttings_slide');
  let $puff_cuttings_slides_current = 1;
  setInterval(function () {
    $puff_cuttings_slides.removeClass('active');
    $puff_cuttings_slides.eq($puff_cuttings_slides_current).addClass('active');
    $puff_cuttings_slides_current = ($puff_cuttings_slides_current + 1) % $puff_cuttings_slides.length;
  }, 2000);
}

$(document).ready(function () {
  // const $slides = $('.klaw-hero_slide');
  // let current = 1;
  // setInterval(function () {
  //   $slides.removeClass('active');
  //   $slides.eq(current).addClass('active');
  //   current = (current + 1) % $slides.length;
  // }, 5000);

  $('.klaw-hero').each(function () {
    const $hero = $(this);
    const $slides = $hero.find('.klaw-hero_slide');
    let current = 1;

    if ($slides.length <= 1) return; // safety check

    setInterval(function () {
      $slides.removeClass('active');
      $slides.eq(current).addClass('active');
      current = (current + 1) % $slides.length;
    }, 5000);
  });

  $(".healthy-boring_wrapper").slick({
    dots: true,
    arrows:false,
    autoplay:true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('.review-testi-blocks').slick({
    centerMode: true,
    slidesToShow:1,
    centerPadding: '360px',
    dots: false,
    arrows: true,
    swipe: true,
    //  infinite: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 1,
          centerPadding: '400px',
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1190,
        settings: {
          slidesToShow: 1,
          centerPadding: '200px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: '50px',
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.videos_list .video_wp').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: false,
   dots: true,
   infinite:false,
   autoplay: false,
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
 });

  $('.category-list-blocks.sliderr').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   arrows: false,
   dots: true,
   infinite:false,
   autoplay: false,
   responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: 'unslick'
      }
    ]
 });

 $('.play-video').on('click', function () {
    const $wrapper = $(this).closest('.video_wpp');
    const $video = $wrapper.find('video')[0];

    // If the clicked video is already playing, pause it
    if ($wrapper.hasClass('playing')) {
      $video.pause();
      $wrapper.removeClass('playing').addClass('paused');
    } else {
      // Pause all other videos
      $('.video_wpp.playing').each(function () {
        const otherVideo = $(this).find('video')[0];
        otherVideo.pause();
        $(this).removeClass('playing').addClass('paused');
      });

      // Play this video
      $video.play();
      $wrapper.addClass('playing').removeClass('paused');
    }
  });

  $(".slideVideo").on("play", function() {
    var currentVideo = this;
    $(".slideVideo").each(function() {
      if (this !== currentVideo) {
        this.pause();
      }
    });
  });


  $(".video_wp").on("afterChange", function (event, slick, currentSlide, nextSlide){
    $('.videos_list').find('.video_main').each(function(){
      var vdid = $(this).find('video').attr('id');
      var videoele = $('#'+vdid).get(0);
      videoele.pause();    
      videoele.muted = false;
      $('.video_wpp').removeClass('playing');
      $(this).find('.video_wpp').addClass('paused'); 
    });    
  });

  $('body').on('click','.header-drawer-sec-open', function(){
    $('body').addClass('overflow-hidden');
    $(this).closest('.klaw-minus').find('.header-drawer-sec').addClass('drawer-open');
  })
  $('body').on('click','.header-drawer-sec-close, .header-drawer-sec-overlay', function(){
    $('body').removeClass('overflow-hidden');
    $(this).closest('.klaw-minus').find('.header-drawer-sec').removeClass('drawer-open');
  })
  $('.grandchild-arrow').click(function() {
    $(this).toggleClass('active');
    $(this).next('.h-drawer-sec__dropdown').slideToggle(); 
  });

  $('body').on('click','.article-nav-section a', function(){
    var selectr = $(this).attr('data-toscroll');
    console.log('selectr',selectr);
    var mm = $(this).closest('.main-article-sec-inner').find('.article-body_content h2.'+selectr);
    if(mm.length > 0){
      $('html, body').animate({
        scrollTop: mm.offset().top
      }); 
    }    
  });

  if($(window).width() < 767 && $("body").hasClass('template-article')){
    var header = $(".main-article-sec-table-media");
    var offtop = header.offset().top;
    $(window).scroll(function() {    
      console.log(window.pageYOffset, offtop);
      if (window.pageYOffset > offtop) {
        header.find('.article-nav-section').addClass("fixed");
      } else {
        header.find('.article-nav-section').removeClass("fixed");
      }
    }); 
  }   

  $('body').on('change','.article-nav-section .scroll_selector', function(){
    var selectr = $(this).val();
    console.log(selectr);
    var mm = $(this).closest('.main-article-sec-inner').find('.article-body_content h2.'+selectr);
    if(mm.length > 0){
      $('html, body').animate({
        scrollTop: mm.offset().top - 80
      }); 
    }    
  });
  
  $('body').on('click','.product-tab-li', function() {
    $('.product-tab-li').removeClass('active');    
    $(this).addClass('active');  
    var sel = $(this).attr('data-title');
    console.log('sel',sel);
    $('.pro-tab-content').removeClass('active').filter('[data-content="' + sel + '"]').addClass('active');
  });

  $('.faq-tab-block-que').click(function(){
     $(this).toggleClass('active'); 
      $(this).next('.faq-tab-ans').slideToggle();
  });

  $('.recipe-video-blocks').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: false,
   dots: true,
   infinite:false,
   autoplay: false,
   responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
 });
 $('body').on('click', '.product-tab-li', function () {
    var target = $(this).data('title');
    if (target === 'recipe') {
        $('.recipe-video-blocks.slick-slider').slick('refresh');
    }
});

});
$('.circular-ingredients_btn').click(function(e){
    e.preventDefault();
  $('.circular-ingredients_btn').removeClass('active');
  $(this).addClass('active');
  $('.circular-ingredients_popup').hide();
  $('body').addClass('stop-scroll');
  
  var activeTab = $(this).attr('href');
  $(activeTab).fadeIn();
  return false;
});
$('.circular-ingredients_popup-close').click(function(e){
  e.preventDefault();
  $('.circular-ingredients_popup').hide();
  $('body').removeClass('stop-scroll');
  return false;
});